import {OpenSans} from '@nolimitcity/slot-launcher/bin/loader/font/OpenSans';
import {FontWeight} from '@nolimitcity/slot-launcher/bin/loader/font/FontStatics';
import { Helper } from '../../../core/utils/Helper';
import { GameSetting } from '../../../core/setting/GameSetting';
import { ContinueButton } from '@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton';
import { TranslationConfig } from '../../config/translate/TranslationConfig';

export class PopUpWindow extends PIXI.Container {

    private _popUpTextStyle: PIXI.TextStyle = new PIXI.TextStyle({
        align: 'center',
        wordWrap: true,
        breakWords: true,
        wordWrapWidth: 420,
        fontFamily: OpenSans.FAMILY,
        fontWeight: FontWeight.REGULAR,
        fontSize: 24,
        fill: 0xffffff,
    });

    private _popUpText: PIXI.Text;
    private _popCornerText: PIXI.Text;
    private _continueButton: ContinueButton;
    private btnCntCB:Function | undefined;
    private bgInfoGraphic:PIXI.Graphics;
    private get boxWidht(): number { return 520; }
    private get boxHeight(): number { return 250; }

    private animationTL:gsap.core.Timeline;

    constructor() {
        super();
        this.init();
    }

    public show(durr: number = 0.3, cb?:Function): void {
        this.animationTL = Helper.setTimeline(this.animationTL);
        if(cb) this.btnCntCB = cb;

        if (!GameSetting.replayMode) {
            this._continueButton.enable(!!cb);
            this.animationTL.to(this, {
                alpha: 1,
                duration: durr,
            });
        }
    }

    public hide(durr: number = 0.4): void {
        this.animationTL = Helper.setTimeline(this.animationTL);
        this.animationTL.to(this, {
            alpha: 0,
            duration: durr
        });
    }

    public setTextbyIndx(indxChoice: number,level:number): void {

        if(level <= 2){
            this._popCornerText.text = ((1/6)*100).toFixed(2)+"%";
        }else if(level <= 4){
            this._popCornerText.text = ((1/5)*100).toFixed(2)+"%";
        }else{
            this._popCornerText.text = ((1/7)*100).toFixed(2)+"%";
        }

        this._popCornerText.visible = indxChoice === 2;
        this._popUpText.text = indxChoice === 1 ? GameSetting.translate(TranslationConfig.COLLECT) + TranslationConfig.GAMBLE_A + level + (level > 1 ? TranslationConfig.GAMBLE_B_PLURAL : TranslationConfig.GAMBLE_B) :
            GameSetting.translate(level > 4 ? TranslationConfig.GAMBLE_CAP : TranslationConfig.GAMBLE_SKIP );
    }

    private init(): void {

        this.bgInfoGraphic = this.addChild(new PIXI.Graphics());

        this.bgInfoGraphic.clear();
        this.bgInfoGraphic.lineStyle(3, 0xFFFFFF, 1);
        this.bgInfoGraphic.beginFill(0x000000, 0.75);

        this.bgInfoGraphic.drawRoundedRect(
            0, 0, this.boxWidht, this.boxHeight,14);
       
        this.bgInfoGraphic.endFill();

        this._popUpText = this.addChild(new PIXI.Text("", this._popUpTextStyle));
        this._popUpText.anchor.set(0.5, 0.5);
        this._popUpText.position.set(this.boxWidht/2, 80);
        
        this._popCornerText = this.addChild(new PIXI.Text((1/6).toFixed(2) + "%", this._popUpTextStyle));
        this._popCornerText.anchor.set(0.5, 0.5);
        this._popCornerText.position.set(this.boxWidht - this._popCornerText.width, 18);
        
        this.createInteractiveModules();
    }

    private createInteractiveModules(): void {
        this._continueButton = this.addChild(new ContinueButton(GameSetting.translate(TranslationConfig.CONFIRM)));
        this._continueButton.enable(false);

        this._continueButton.addClickCallback(() => { 
            if(this.btnCntCB){
                this.btnCntCB();
                this.hide();
            }
            this._continueButton.enable(false);
        });

        this._continueButton.x = this.boxWidht/2 - this._continueButton.width/2;
        this._continueButton.y = this.height/2 + this._continueButton.height/2;
    }

    public getWinCapProbabilityText(probValue:number): string {
        let text: string = '';
        return text;
    }
    
}
